import { render, staticRenderFns } from "./NonActive.vue?vue&type=template&id=680122b0&lang=html"
import script from "./NonActive.vue?vue&type=script&lang=js"
export * from "./NonActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports